import HouseScreen from './HouseScreenContainer';
export default HouseScreen;
